import React from 'react';
import { useIntl, FormattedMessage } from 'react-intl';
import { withTheme } from 'styled-components';
import { ExternalLink } from 'shared-components';
import { authEn,authFr } from '../../../../i18n/auth';


export default withTheme(({theme  }) => {
  const intl = useIntl();
  if (intl.locale === 'fr') {
    return (
      <ExternalLink
        href={theme.brand.activateCardholderAgreementFr}
        target="_blank"
        rel="noopener noreferrer"
      >
        <FormattedMessage
          id="activate-cardholder-agreement-link"
          description="Label for Cardholder Agreement"
          defaultMessage={authFr['activate-cardholder-agreement-link']}
        />
      </ExternalLink>
    );
  }
  return (
    <ExternalLink
      href={theme.brand.activateCardholderAgreementEn}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage
        id="activate-cardholder-agreement-link"
        description="Label for Cardholder Agreement"
        defaultMessage={authEn['activate-cardholder-agreement-link']}
      />
    </ExternalLink>
  );
});
